import Vue from 'vue';
import Router from 'vue-router';
import { routes } from './routes';
import store from '@/store';
Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: routes,
});


router.beforeEach((to, from, next) => {
  store.commit('orders/SET_ROUTE', to.name);
  const dirty = JSON.parse(sessionStorage.getItem('dirty'));
  if (dirty)
    Vue.dialog
      .confirm({
        title: 'Unsaved Changes',
        body: 'Changes will be lost, Do you want to proceed?',
      })
      .then(function () {
        next();
      })
      .catch(function () {
        next(false);
      });
  else next();
});
export default router;
